import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 5px;
  border: 3px solid ${({ theme }) => theme.colors.lightGrey};
  width: 356px;
  z-index: 5;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-weight: 500;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.softBlack};
    }
  }

  button {
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: ${({ theme }) => darken(0.05, theme.colors.white)};
    }
  }
`;

export const WeekDays = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 18px;

  span {
    width: 40px;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey};
  }
`;

export const Days = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  button {
    span {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.softBlack};
    }

    &:hover {
      background-color: ${({ theme }) => darken(0.03, theme.colors.white)};
    }

    &.different-month {
      span {
        color: ${({ theme }) => darken(0.15, theme.colors.white)};
      }
    }

    &.today {
      border: 3px solid ${({ theme }) => darken(0.05, theme.colors.main)};
    }

    &.start,
    &.end {
      background-color: ${({ theme }) => darken(0.05, theme.colors.main)};

      span {
        color: ${({ theme }) => theme.colors.white};
      }
    }

    &.start {
      border-radius: 5px 0 0 5px;
    }

    &.end {
      border-radius: 0 5px 5px 0;
    }

    &.between {
      border: 3px dashed ${({ theme }) => darken(0.1, theme.colors.white)};
    }
  }
`;
